import {
  ArpMediaNotificationModel,
  PaginatedResponse,
  PaginationParams,
  SamplePack
} from '@arpeggi/shared'
import { useAuth } from '../../hooks/useAuth'
import axios from '../../lib/axios'
import { objectToFormData } from '../../utils/api'

export interface GetSamplePacksParams
  extends Omit<PaginationParams<SamplePack>, 'user' | 'metadata'> {
  sampleIds?: number[]
  search?: string
  hasCoverArpMedia?: boolean
}

export interface CreateSamplePackDto {
  title: string
  description: string
  userId: number
  coverImage: File
  soundIds: number[]
  project?: { name: string; url: string }
  coverArpMediaId?: number
}

export type UpdateSamplePackDto = Partial<
  Omit<CreateSamplePackDto, 'project' | 'coverArpMediaId' | 'file'>
> & { project?: null | { name: string; url: string }; coverArpMediaId?: number | null; file?: File }

export interface GetSamplePackNotificationsParams
  extends PaginationParams<Omit<ArpMediaNotificationModel, 'data'>> {}

export const getSamplePacks = async (params: GetSamplePacksParams) => {
  const { data } = await axios.get<PaginatedResponse<SamplePack>>('/api/v2/sample-packs', {
    params
  })

  return data
}

export const getSamplePackNotifications = async (
  id: number,
  params: GetSamplePackNotificationsParams
) => {
  const { data } = await axios.get<PaginatedResponse<ArpMediaNotificationModel>>(
    `/api/v2/sample-packs/${id}/notifications`,
    { params }
  )

  return data
}

export const useSamplePacksAPI = () => {
  const { authenticatedPost, authenticatedPatch, authenticatedDelete } = useAuth()

  const createSamplePack = async (dto: CreateSamplePackDto) => {
    const { data } = await authenticatedPost<SamplePack>(
      '/api/v2/sample-packs',
      objectToFormData(dto)
    )

    return data
  }

  const updateSamplePack = async (id: number, dto: UpdateSamplePackDto) => {
    const { data } = await authenticatedPatch<SamplePack>(
      `/api/v2/sample-packs/${id}`,
      objectToFormData(dto)
    )

    return data
  }

  const deleteSamplePack = async (id: number) => {
    return authenticatedDelete(`/api/v2/sample-packs/${id}`)
  }

  return { createSamplePack, updateSamplePack, deleteSamplePack }
}
